import React, { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getWorkerOwnerExistsValue } from "../../../../../Actions/API/AuthenticationActions"
import { acceptInvitationAsWorker } from "../../../../../Actions/API/Org/OrgMemberActions"
import { useAppState } from "../../../../../Hooks/useReduxState"
import { routePaths } from "../../../../../Routes"
import { InvitationAccept } from "../../Common/InvitationAccept"

interface WorkerSignUpProps {
    orgUsername: string
    workerId: number
    code: string
}

export function WorkerSignUp({
    orgUsername,
    workerId,
    code
}: WorkerSignUpProps) {
    const dispatch = useDispatch()
    const email = useAppState(
        state => state.api.authentication.workerOwnerExists[workerId]?.email
    )
    const invitation = useMemo(
        () => ({
            type: "organization-worker" as const,
            orgUsername,
            workerId,
            code
        }),
        [code, orgUsername, workerId]
    )

    useEffect(() => {
        if (email === undefined) {
            dispatch(getWorkerOwnerExistsValue(workerId, code))
        }
    }, [code, dispatch, email, workerId])

    return (
        <InvitationAccept
            invitation={invitation}
            email={email}
            acceptAction={acceptInvitationAsWorker(workerId)}
            redirectRouteOnComplete={routePaths.orgHome(orgUsername)}
        />
    )
}
